import type { Environment, Tracker } from "@infinitaslearning/module-data-analyticstracker"
import { createTracker } from "@infinitaslearning/module-data-analyticstracker"
import { useEffect, useMemo } from "react"
import { config } from "../config"
import { Opco } from "../models"
import { useOpco } from "./useOpco"

const getTrackerOpco = (opco: Opco): "noordhoff" | "plantyn" | "liber" => {
  switch (opco) {
    case Opco.Plantyn:
      return "plantyn"
    case Opco.Liber:
      return "liber"
    case Opco.Noordhoff:
    default:
      return "noordhoff"
  }
}

const getTrackerEnvironment = (environment: string): Environment => {
  return environment === "development" ? "acceptance" : (environment as Environment)
}

export function useTracker(): Tracker {
  const opco = useOpco()

  const tracker = useMemo(
    () =>
      createTracker({
        platform: "SeAtlas",
        opCo: getTrackerOpco(opco),
        platformVersion: "1.2.3",
        environment: getTrackerEnvironment(config.environment)
      }),
    [opco]
  )

  // biome-ignore lint/correctness/useExhaustiveDependencies: only run once on mount
  useEffect(() => {
    tracker.awaitInitialized().then(() => {
      tracker.listen()
    })
  }, [])

  // Needed to use the tracker in the redux actions without passing it as a parameter
  window.tracker = tracker
  return tracker
}

declare global {
  interface Window {
    tracker?: Tracker
  }
}
